module.exports = __webpack_public_path__ + "static/cs-logo-90c42ad095fcc6bd9348c0c2c4336a1b.png";